import { DOMAIN } from "../../thor.const";
import { Enums, Events } from "../../thor.enums";
import { thor } from "../../typings/thor";

export class FilterSiteController {
    public static $inject: string[] = ["$scope", "$translate", "$rootScope"];

    // binded
    public filterParams: thor.SearchFilterParams;
    public isIe: boolean;
    public context: string;

    public sites: any[];
    public types: any[];
    public isPast: boolean;

    private isDuo: boolean;
    private site: Enums.Site;
    private organizationsSelectedAreMonoSite: boolean;

    constructor(
        $scope: ng.IScope,
        $translate: ng.translate.ITranslateService,
        private $rootScope: ng.IRootScopeService
    ) {
        this.sites = Object.values(Enums.Site).map(site => ({ [site]: DOMAIN[site] }));
        this.types = Object.values(Enums.AuctionType).map(type => ({ [type]: $translate.instant(type) }));

        $scope.$watch(
            () => ({
                isDuo: this.isDuo,
                site: this.site,
                filterParamSite: this.filterParams.site,
                context: this.context
            }),
            (current, previous) => {
                this.isPast = this.context.includes("past");

                if (!this.isPast) {
                    this.site = Enums.Site.Interencheres;
                }

                // reset site filter on form reinitialization
                if (current.filterParamSite !== previous.filterParamSite && current.filterParamSite === undefined) {
                    this.site = undefined;
                }

                // reset duo filter
                this.isDuo = this.site ? this.isDuo : undefined;

                // reset type filter
                Object.values(Enums.Site).forEach(s => (this.filterParams[`sites.${s}.type`] = undefined));

                // set site filter
                this.filterParams.site = `${this.isDuo ? "contains:" : ""}${this.site || ""}` || undefined;
            },
            true
        );

        this.$rootScope.$on(Events.OrganizationFilterUpdated, (_event, organizationsSites) => {
            this.organizationsSelectedAreMonoSite = organizationsSites.length === 1;
            this.site = this.organizationsSelectedAreMonoSite ? organizationsSites[0] : undefined;
        });
    }
}
